import type { NodeType, ResolvedPos, Schema } from '@atlaskit/editor-prosemirror/model';

export function isWithinSameCell({
	$from,
	$to,
	schema,
}: {
	$from: ResolvedPos;
	$to: ResolvedPos;
	schema: Schema;
}): boolean {
	const { tableCell, tableHeader } = schema.nodes;
	let startMaybeCellNode;
	for (let depth = $from.depth; depth > 0; depth--) {
		if ([tableCell, tableHeader].includes($from.node(depth).type)) {
			startMaybeCellNode = $from.node(depth);
			break;
		}
	}
	if (!startMaybeCellNode) {
		// Early exit as $from is not in a cell
		return false;
	}

	let endMaybeCellNode;
	for (let depth = $to.depth; depth > 0; depth--) {
		if ([tableCell, tableHeader].includes($to.node(depth).type)) {
			endMaybeCellNode = $to.node(depth);
			break;
		}
	}

	if (!endMaybeCellNode) {
		// Early exit as $to is not in a cell
		return false;
	}

	return startMaybeCellNode.eq(endMaybeCellNode);
}

export function getPositionNodeTypeDepth({
	resolvedPos,
	nodeType,
}: {
	nodeType: NodeType;
	resolvedPos: ResolvedPos;
}) {
	for (let depth = resolvedPos.depth; depth > 0; depth--) {
		if (resolvedPos.node(depth).type === nodeType) {
			return depth;
		}
	}
	return;
}
